import { FormControl, FormGroup } from '@angular/forms';
import { IBeegoAppointment, IDeleteBeegoAppointment } from '@internal-models/beego-appointment.model';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { CommunicationFormFactory } from './communication-form.factory';

export class DeleteBeegoAppointmentFormFactory {
	public static create(beegoAppointment: IBeegoAppointment): IFormGroup<IDeleteBeegoAppointment> {
		return new FormGroup({
			id: new FormControl(beegoAppointment.id, [SharedFormValidators.required]),
			reason: new FormControl(null, [SharedFormValidators.required]),
			replyTo: new FormControl(beegoAppointment.replyTo),
			telephone: new FormControl(beegoAppointment.telephone),
			Communication: CommunicationFormFactory.create(true),
		}) as IFormGroup;
	}

	public static getValue(form: IFormGroup<IDeleteBeegoAppointment>): IDeleteBeegoAppointment {
		return form.value;
	}
}
